
var modal_id;
var room_id;
var images = {};
const magnify_event = new Event('magnify');

// Listen for the event.
// elem.addEventListener('build', function (e) { /* ... */ }, false);

// Dispatch the event.

$( document ).ready( function() {

	
	room_id = window.location.pathname.substring(1);


			$("area").on("click keypress", () => {
	      if ( event.which == 13 || event.type == "click" ) {
	        event.preventDefault();
					modal_id = $(event.target).data('modal');
					change_modal(modal_id, room_id, 1, true)
	      }
	    })

		$(".x").click(function(event) {
			if ($(".modal").hasClass('media')) {
				$(".image").removeClass('big')
				$(".modal").removeClass("media");
				$(".modal div:not(.image):not(.img-magnifier-glass):not(.x)").removeClass('none');;
				if ($(".image-image")[1] != undefined) {
					$(".image-image").removeClass('none');
					$("span").removeClass('none compress-image').addClass('expand-image');
				}
				modal_image_buttons()
			} else {
				$(".modal").removeClass("active");
				$(".embed-container").html("")
				$("audio").remove()
			}
		});

		$(".magnify").click(e => {
			$("#magnify").toggle()
		})

	$("img#room").click(function(event) {
		if ($(event.target).hasClass("magnified")) {
			$(".img-magnifier-glass").hide()
			$("img#room").removeClass("magnified")
		}else {
			$("img#room").addClass("magnified")
			$(".img-magnifier-glass").show()
			magnify(event.target.id, 3, event)
		}
	})
	

		$(".image").click(function(event) {
			if ($(event.target).hasClass('image-image')) {
				if ($(event.target).hasClass("magnified")) {
					$(".img-magnifier-glass").hide()
					$(".image-image").removeClass("magnified")
				}else {
					$(".image-image").addClass("magnified")
					$(".img-magnifier-glass").show()
					magnify(event.target.id, 3, event)
				}
			}else if ($(event.target).hasClass('img-magnifier-glass') ) {
				$(".img-magnifier-glass").hide()
				$(".image-image").removeClass("magnified")

			}else if ($(event.target).hasClass('resize-image')) {
				if ($(".image-image")[1] != undefined) {
					$(".image-image").not("#"+$(event.target).data("image")).toggleClass('none');
					$("span").not(event.target).toggleClass('none');
				}
				$(".modal div:not(.image):not(.img-magnifier-glass):not(.x)").toggleClass('none');;
				$(".modal").toggleClass('media')
				$(".image").toggleClass('big')

				setTimeout(function () {
					modal_image_buttons()
				}, 10);
				$(event.target).toggleClass('expand-image').toggleClass('compress-image');;
			}
		});

		$(".dots").on('click', "span[data-page]" ,e => {
			// console.log("yay!");
			const page_id = $(e.target).data('page');
			// console.log(page_id);
			change_modal(modal_id, room_id, page_id, false)
		});

		$("[data-page]").click( e => {
			// console.log(e.target);
			const page_id = $(e.target).data('page');
			// console.log(page_id);
			change_modal(modal_id, room_id, page_id, false)
		});

		$(document).keydown(function(event) {
			if ($(".modal").hasClass("active")) {
				if (event.which == 27) {
					if ($(".modal").hasClass("media")) {
	  				 $(".resize-image").click()
	  			 }else {
	  				 $(".x").click()
	  			 }
				} else if ($(".modal:not(.media)").hasClass('active')) {
						let page_id
						if ( event.which == 37 ) {
							page_id = $("div.left").data('page');
						}
						else if ( event.which == 39 ) {
							page_id = $("div.right").data('page');
						}
						if (page_id != undefined) {
							change_modal(modal_id, room_id, page_id, false)
						}
				}
			}
		});
		change_modal = (modal_id, room_id, page_id, first) => {
			$("span[data-page]").removeClass('active')
			// $(".modal").addClass('active');
			$(".modal").removeClass().addClass('modal active')
			// $(".modal").addClass('modal active')
			$(".image").removeClass('has-after')
			$(".embed-container").html("")
			$(".modal-text").html("")
			// $('.image').children("img").remove()
			$('.image').html("")
			$(".embed-container").html("")

			if ($(".modal").hasClass("media")) {
				$(".modal").css("width", "100vw" )
			}else {
				let image_width =   $("img#room").width()
				let modal_width = image_width - (window.innerHeight * 0.05)
				$(".modal").css("width", modal_width + "px" )
			}

			const room_title = modals[room_id].title
			const modal_data = modals[room_id][modal_id];
			const page_data = modals[room_id][modal_id][page_id];
			const title = modal_data.title;
			const content = page_data.content;
			const after = page_data.after;
			const image = images[page_data.image]
			let grid = page_data.images
			const music = page_data.music
			const video = page_data.video
			const page_num =  Object.keys(modal_data).length - 1
			const author = page_data.author
			const columns = page_data.columns
			const columnsTitle = page_data.columnsTitle
			const columnsSubtitle = page_data.columnsSubtitle

			$("h1 span:first-child").html(room_title)
			$("h1 span:nth-child(2)").html(title)
			// console.log(page_id);

			if (page_id == page_num) {
				$(".left").data("page", 1)
			}else{
				$(".left").data("page", page_id + 1)
			}

			if (page_id == 1) {
				$(".right").data("page", page_num)
			}else{
				$(".right").data("page", page_id - 1)
			}

			if (first) {
				$(".dots").html("")
				for (var i = 0; i < page_num; i++) {
					$(".dots").append("<span data-page='" + (i+1) + "'>" + (i+1) + "</span>")
				}
				for (const [key0, value0] of Object.entries(modal_data)) {
				  // console.log(`${key}: ${value}`);
					if (typeof(value0) == 'object') {
						for (const [key1, value1] of Object.entries(value0)) {
							if (key1 == "image") {
								// console.log(`${key1}: ${value1}`);
								// preloadImage(value1)
							}
						}
					}


				}
			}
			$("span[data-page=" + page_id + "]").addClass('active')

			if (content != undefined) {
				var selectorToAppend = ".modal-text"
				if (columns) {
					$(".modal-text").append("<div class='columns-header'><h3>" + columnsTitle + "</h3></div>")
					if (columnsSubtitle != undefined){
					$(".columns-header").append("<h4>" + columnsSubtitle + "</h4>")
					}
					$(".modal-text").append("<div class='columns'></div>")
					selectorToAppend = ".columns"
				}else {
					$(".modal-text").removeClass("columns")
				}
				const splitted = content.split("\n")
				const last_p = splitted.filter(item => item).length
				let count_p = 0
				for (var i = 0; i < splitted.length; i++) {
					if (splitted[i] == "") {
						$(selectorToAppend).append("<br>")
					}else {
						count_p++
						if (author && count_p == last_p) {
							$(selectorToAppend).append("<p class='last'>" + splitted[i] + "</p>")
						}else {
							$(selectorToAppend).append("<p>" + splitted[i] + "</p>")
						}
					}
				}
				// console.log(splitted);
				if (image == undefined) {
					$(".modal").addClass('no-image')

				}else {
					// $(".image").html("<img class='loading zoom' src='" + image + "' />")
					$(".image").append("<img id='image_0' class='loading zoom image-image image-magnifier-container' src='" + image + "' />")
					$("img#image_0").last().on("load", () => {
						modal_image_buttons()
					})
				}
				if (page_data.matching_game) {
					$(".modal").addClass("matching_game")
				}
			}
			else if (content == undefined && image != undefined) {
				$(".modal").addClass('only-image')
				$(".image").append("<img class='loading zoom image-magnifier-container image-image'  id='image_0' src='" + image + "' />")
				$("img#image_0").on("load", () => {
					modal_image_buttons()
				})
			}
			else if (content == undefined && grid != undefined) {
				$(".modal").addClass('grid')
				$(".image").html("")
				// grid = []
				grid.forEach((img, i) => {
					// grid.push(images[img])
					$(".image").append("<img id='image_" + i + "' class='loading image-image image-magnifier-container' src='" + images[img] + "' />")
					// console.log($(".image img")[i]);

				});
				$(".image img").on("load", () => {
					modal_image_buttons()
				})

				if (grid.length == 3) {
					$(".image img").addClass('three')
				}else {
					$(".image img").removeClass('three')
				}

			}
			else if (video != undefined) {
				$(".modal").addClass('video')
				$(".embed-container").append("<iframe src='" + video + "' frameborder='0' allowfullscreen></iframe>")
			}

			if (after != undefined) {
				$(".image").addClass('has-after')
				$(".has-after").attr('data-after',after);
			}
			if (music != undefined) {
				$(selectorToAppend).append("<audio autoplay	loop controls controlsList='nodownload' src='" + images[music] + "'>	Your browser does not support the	<code>audio</code> element.</audio><br><br>")
		}
		// $(".zoom").forEach((image, i) => {
		// 	magnify("image", 3)
		// });
		// document.dispatchEvent(magnify_event);

	}


		
			images["tnuat-noar-2-bund.jpg"] =  "/assets/room_1/tnuat-noar-2-bund-71143c391b5d504edf8c7d9ff9f3003ed04a6831a4b5c90f995baa4b060f1335.jpg"
		
			images["women-sport.webp"] =  "/assets/room_1/women-sport-c74589201cd93db6248ad826d561f787c4d6e4fe831751e3f8b9bacc4a729a71.webp"
		
			images["needs.svg"] =  "/assets/room_1/needs-2078214dca34e5b55c1e041e6c97186c15a68a0736c65ce948d2562aa380f854.svg"
		
			images["inside-tikochin-synagogue.jpg"] =  "/assets/room_1/inside-tikochin-synagogue-7ebb7883d9b4a0dfcbb0092f750783adb4ca76057cdeaafb8690f5383217ecce.jpg"
		
			images["field.webp"] =  "/assets/room_1/field-93e6c225e5ed64bd28209424f2805baed405e93202ae9091407ed11ec2f4401d.webp"
		
			images["hasandlar.webp"] =  "/assets/room_1/hasandlar-282f7ddfae8d3e4a88f81c6bc9c2ca1c375538a17d41ebdbf6955d0634fa6fbc.webp"
		
			images["iztur-hutei-pishtan.webp"] =  "/assets/room_1/iztur-hutei-pishtan-cc7d9ac709baa37a8253b22b1fe166e8e5313104365d280d666562ff16b73c99.webp"
		
			images["rabbi-teaching.jpg"] =  "/assets/room_1/rabbi-teaching-9272873e638f2baae8910d4a74b4124cd33c07b43c259b5951b86652ac715e8a.jpg"
		
			images["traditional-family.webp"] =  "/assets/room_1/traditional-family-7653543e3e5d296fd4523b23a9e4a898af7de4f2822bb7b877c64bb586bedd6d.webp"
		
			images["tarbut-school.webp"] =  "/assets/room_1/tarbut-school-407fdd8e4595771548258e134ee55021146688881c58ec8d84262521467fcb93.webp"
		
			images["mozeg-habar.webp"] =  "/assets/room_1/mozeg-habar-cab725550937252a6a7b98cc9276e91db0f9478ce3de661f7695f5c9e1f4233e.webp"
		
			images["hanapah.webp"] =  "/assets/room_1/hanapah-657dcd541671619d7db15327a79e2b334c8b0070f8b505cd416187b5db37a797.webp"
		
			images["street.webp"] =  "/assets/room_1/street-cf8e5ea58ab9d3dc8f48088db0868894f20d37423acbd4d56e1e9c100f285682.webp"
		
			images["schools.webp"] =  "/assets/room_1/schools-03b1dc31bb0bafa8430ded1da4bc9a71d630a2873234c55682508580b47f1288.webp"
		
			images["needs.png"] =  "/assets/room_1/needs-dccb63f69423ba18311e259d62b4cf090ed462838520c4991b7b5fb5c4f2780c.png"
		
			images["tnuat-noar-4-two-girls.jpg"] =  "/assets/room_1/tnuat-noar-4-two-girls-4c80497bc1ad4c0c7731bacf29d7bfdac0bad3056dffec192faebf2295f6f57b.jpg"
		
			images["sadnaot-avoda.webp"] =  "/assets/room_1/sadnaot-avoda-4f21903c28ab9351e6dbd3ab092e138b901dfa6d5e231468a36edeacc65d77bc.webp"
		
			images["leon-with-name.webp"] =  "/assets/room_1/leon-with-name-970d3c2352e059da0b1fd54b9b4469136bd46270a5a37ca3afce126e1be738ac.webp"
		
			images["bundists2.webp"] =  "/assets/room_1/bundists2-b6a093261235f4ed769797e44c3d124dfb18e9eb18ef69b5fa081f0fd928afb3.webp"
		
			images["zisha.webp"] =  "/assets/room_1/zisha-95fa3e5b347d9f7523aa741ed67d059bd7e9b1dda6c1c1872c30e0cd3167a498.webp"
		
			images["yiddish-song-md.mp3"] =  "/assets/room_1/yiddish-song-md-5d9bc080f108b9bb66c83675c23cf5ca5d923dabbdc1e70c5d50eab03a9afdeb.mp3"
		
			images["passover.webp"] =  "/assets/room_1/passover-c639d7b1ff89b49ea899accd9d75378e63589a2201d64470559b701f1136c6df.webp"
		
			images["sapar.webp"] =  "/assets/room_1/sapar-57219823111a5d638fbe61935358b7fafa0c902bee3d46773e597e3e6d5d4d5f.webp"
		
			images["jewish-boy.webp"] =  "/assets/room_1/jewish-boy-1c4b1ac2e2e58a27b138ab7f74bfaa0196ad8a24f08cf6cbd8292079367cb016.webp"
		
			images["bundists1.webp"] =  "/assets/room_1/bundists1-ff0352b011a97ad8cb58d17edf96204a6d6237a83a02e684b3d4f3045a74b631.webp"
		
			images["bundists3.webp"] =  "/assets/room_1/bundists3-a12d1e99e73c48cfbe81218d4a0fe08aed4da8a3cd0d6ab1ed135bc871caafb3.webp"
		
			images["population.webp"] =  "/assets/room_1/population-6a888f43bc48e72d2ec8f2670875d311b011a0388c631e1a2b24a46cfad54658.webp"
		
			images["girls.webp"] =  "/assets/room_1/girls-1556e25d51447145da2aeb6df4ab2d1a3dd108f57a032b105b10daf27af1c28a.webp"
		
			images["tnuat-noar-1.jpg"] =  "/assets/room_1/tnuat-noar-1-78082ea174d65c5e2ae2d29dc2c0db853e11313854da87233f324457f71baad3.jpg"
		
			images["shalom-aliehem.jpg"] =  "/assets/room_1/shalom-aliehem-1cc48d35339caa4a5cf0829d5898aa08bff8fcc756b05c1f4885d8cd62d69a22.jpg"
		
			images["semel-polin.webp"] =  "/assets/room_1/semel-polin-68495e6906cb8386cd58f2615ef26f4a1a27e75464e94b83c39c5f5bb7dbdbe3.webp"
		
			images["outside-tikochin-synagogue.jpg"] =  "/assets/room_1/outside-tikochin-synagogue-f7c79652d8193e94cdb844f5b93213e8aa031cfecafb030ac707ce36702476b8.jpg"
		
			images["shuk-eglon-square.webp"] =  "/assets/room_1/shuk-eglon-square-450b05515df5a98a7face5454108c9b2bfac0332da3d0959ed5e376c19f2725b.webp"
		
			images["gans.webp"] =  "/assets/room_1/gans-f28f1d28fe50a84b3667a06f4d8202d54d7a128ff4778c5261fb060e047bd4a2.webp"
		
			images["yiddish-song-sm.mp3"] =  "/assets/room_1/yiddish-song-sm-291296ef29e217eb8be817f6169abf5f22f22dbe9a4c56c73135c05bb68d0ed8.mp3"
		
			images["yiddish-2.webp"] =  "/assets/room_1/yiddish-2-3500c84308baf23a2328c666d5b8c89bb345d3169a0028d040b8291b4627a762.webp"
		
			images["yiddish-song.mp3"] =  "/assets/room_1/yiddish-song-cde8acfb1b92e27bc09ba774cb3bb52f32f76a31a940ed937a54133da7af5e6e.mp3"
		
			images["hotvei-etzim.webp"] =  "/assets/room_1/hotvei-etzim-03eb583435068d5d7e0ddab1729028332877a7c4dd3af0d1022a35f0e4bc6401.webp"
		
			images["brothers.webp"] =  "/assets/room_1/brothers-33b0ff3c04ba743044d4f87b3771cc3d22644038711b8e33b80c24433d35de8e.webp"
		
			images["yiddish-school.webp"] =  "/assets/room_1/yiddish-school-97542a2c7dc7a414c8476039a5657fd50e9f0d390dd26e57885ecb06bb7c2bf8.webp"
		
			images["tnuat-noar-3-gramophone.jpg"] =  "/assets/room_1/tnuat-noar-3-gramophone-43eb75b605e520417b04e60bbcb0565b485d10661f638a76ea4259dccb00eb31.jpg"
		
			images["struggle.webp"] =  "/assets/room_1/struggle-8260aa233c2a6da54308219b7dc2e53682107c8787d7b0d15b44e3350090d8e8.webp"
		
			images["city_life.webp"] =  "/assets/room_1/city_life-d126cc65255823cbf3d2011bb9eeb3cc336c2a525dd9bb29b77dc4b978852865.webp"
		
			images["toferet.webp"] =  "/assets/room_1/toferet-7e6f1b07181cf6c15c98f894e70ae2b3cef72097a8766f51b5a7b796a906e157.webp"
		
			images["hatoferet.webp"] =  "/assets/room_1/hatoferet-0bd667af24669e50c78e997b71a83257eb805113d0039184f24c906b04bc8887.webp"
		
			images["shay-agnon.jpg"] =  "/assets/room_1/shay-agnon-b050a4ff8494bf942182967ea6cde9cea8e94e711ca3d1de31239fece9d81121.jpg"
		
			images["artur-shik-zhuiot.webp"] =  "/assets/room_1/artur-shik-zhuiot-eee4e52c6f5d89c8ece0f48e083bf14a32e0bdb5f005b3e83d7782c6c9b1d40a.webp"
		
			images["sefer-harefuot.webp"] =  "/assets/room_1/sefer-harefuot-0605c540a26a994f6ed92e45eb93bd11f10d532b7486e7dbde6efad8cd29ec5b.webp"
		
			images["david-dov-getzel-collage.webp"] =  "/assets/room_1/david-dov-getzel-collage-7df2db123bbcb5cb6a99edf7156293a9ae2d26849b7c71771b2f3c36b64ae6ca.webp"
		
			images["needs.webp"] =  "/assets/room_1/needs-bef664f51e6e2ba5e44a261249e44b59581ebc8cb1597f4a0b72ebc926b9ba46.webp"
		
			images["boys.webp"] =  "/assets/room_1/boys-2fe830fd78f2de9b9ae9b5aa8f72b8791a7234fe0d4cbb108b3ef7302a4ab64e.webp"
		
			images["yiddish-1.webp"] =  "/assets/room_1/yiddish-1-a24ea5afa4a77c78e7eecdb16aca5df380a50e46ee1469a22707f8a3889461b7.webp"
		
			images["ball.webp"] =  "/assets/room_1/ball-07c36acbd4bbe9ee4983b87f78f73b7b30c5000d574dac9aa05d13c5c1d2f5d7.webp"
		
			images["artur-shik-michael-landa.webp"] =  "/assets/room_1/artur-shik-michael-landa-7b5d6deb4c89654115fd02a35f61fcfb57303e8c116959ce9cb6ef0dc1ac8491.webp"
		
			images["haeglon-vemishpahto.webp"] =  "/assets/room_1/haeglon-vemishpahto-f153904d7a3154dc4705abac77f83c3f4809d3d389a500abfbc3a41993c4d5e4.webp"
		
			images["barash.webp"] =  "/assets/room_1/barash-32839f062d79445e1d81487d6797ab342f8c338df79b5cc7ec6f6fc9bd972978.webp"
		
			images["factory_print.webp"] =  "/assets/room_1/factory_print-dc539a6c037a2960f59ae775be345536e5927f361f8c5b0041acdb8a92b6a02e.webp"
		

		
			
				images["clubs.webp"] =  "/assets/room_2/culture/clubs-47665e208d04a7e382d72b2d55533adc38f32cb3b58d1e3e3da1d4652dd09bfe.webp"
			
				images["culture_rodoshevsky.webp"] =  "/assets/room_2/culture/culture_rodoshevsky-968f9b24c9b8b88d6d6d80931fc9302b1116b06527eafd862c4d162544d835f3.webp"
			
				images["quire.webp"] =  "/assets/room_2/culture/quire-d2d3fc50d90695b56c77496fce975cad147c09ca232ffd0b2883fa7989135fd3.webp"
			
				images["concert.webp"] =  "/assets/room_2/culture/concert-75cd7cf770c2f5bbaf1fa988f2bea79bcb54b85983ad2e73394ade5b28fec7f9.webp"
			
				images["theatre.webp"] =  "/assets/room_2/culture/theatre-c68d90e41ddf4bfb6100943d7472b6659c567321ede7084756905b84d81eb42a.webp"
			
		
			
				images["coins.webp"] =  "/assets/room_2/leadership/coins-73a2e438cb40d5a4d05a3a3c0d2414d79866feb1d8228401c05284083dbc8220.webp"
			
				images["warsaw_yudenrat.webp"] =  "/assets/room_2/leadership/warsaw_yudenrat-ac317ca0ed91bda50c1037cba69a69203efaf76a46bb94442d7bf85eb3c91c77.webp"
			
				images["money.webp"] =  "/assets/room_2/leadership/money-4e14dc3bf27d4ce9530e4db7d42ea346fad0aefec374b8a258f68277cf8c116b.webp"
			
				images["apparatus.webp"] =  "/assets/room_2/leadership/apparatus-5f31090c7e76e2f5f20d5fd16608ade839a292eaf4a90f68e54b1879b0b19f6d.webp"
			
				images["jacob.webp"] =  "/assets/room_2/leadership/jacob-d8b1edf4c6afc7f953148687fa0296479f490f922f2b99c2bc6edc7d1a8b5a8d.webp"
			
				images["yakov-efraim.webp"] =  "/assets/room_2/leadership/yakov-efraim-a688acc5e6ae6b2e7952decf8c3acde34e9f39cbbeb8476e582bdcf4b7bb332d.webp"
			
				images["warsaw_police.webp"] =  "/assets/room_2/leadership/warsaw_police-94d68662592df3c12b374a2e4aa0b7f67a48da38b8ab65d030da130036c54186.webp"
			
				images["schwartzman.webp"] =  "/assets/room_2/leadership/schwartzman-65f9c0d8a80e50e078889118ef76cbebad5749d880c97b77558642da5604844f.webp"
			
				images["cohen.webp"] =  "/assets/room_2/leadership/cohen-0fce5be345ccad8683c13a4299fc9af6cc89b73e3d329c48b131eea8f3081787.webp"
			
				images["ramkovsky.webp"] =  "/assets/room_2/leadership/ramkovsky-e59e811fe6ae9415ea9e182157b30e6b234c035bd92480ece73904615b06c011.webp"
			
				images["ava.webp"] =  "/assets/room_2/leadership/ava-990b6dbaf23de4c2c13bf1ceaad74a578e31aa5baeda6182af223cc2cc47db14.webp"
			
				images["efraim.webp"] =  "/assets/room_2/leadership/efraim-1cf7a5632e20dde4217bc6ea0a600f7de1447ddc744bdd370da13294bf200043.webp"
			
				images["lodz_police.webp"] =  "/assets/room_2/leadership/lodz_police-e70aad27d4c0eeff2c56341b50359446935285f2135cf1a8d6da7cc9d334012c.webp"
			
				images["yudenrat.webp"] =  "/assets/room_2/leadership/yudenrat-4a81b0380484b2b7243a7ccfde2dce3a872e63c7b2475afa208abbe2d2179fe5.webp"
			
				images["court.webp"] =  "/assets/room_2/leadership/court-52b961eea3cbd989d6811068e31d3203159fb769cbdda4eeb8344bc7ecef226d.webp"
			
				images["kovna_yudenrat.webp"] =  "/assets/room_2/leadership/kovna_yudenrat-9d46ca86b35a15d35ad262a4e998e9034598d5d71e25f4def7a0c05a6e8b39b3.webp"
			
				images["police.webp"] =  "/assets/room_2/leadership/police-dd498f7e41f961b93975ab3e5a134bef4ba6ab4ad2bdd8e5cfa65a5abbbb1dec.webp"
			
				images["himler.webp"] =  "/assets/room_2/leadership/himler-1330f59135216d59216e00a7a8a47a2345c7bc2aeba0ed931056a5c033cce124.webp"
			
				images["luptin.webp"] =  "/assets/room_2/leadership/luptin-6c5e0d469bf21d7ba05aafbb43c34be41077715357765818e7f77d7f229b58f0.webp"
			
				images["bills.webp"] =  "/assets/room_2/leadership/bills-530f08a6568fe3b3f887df2dddd0f17ca4fb6b15a213f1a2488647323df3a197.webp"
			
				images["cherniakov.webp"] =  "/assets/room_2/leadership/cherniakov-c46ee65e609d8d2fe9ae224d2c464fcc1fc04aed0c3a9a24902a269d5ac125f1.webp"
			
				images["stamp.webp"] =  "/assets/room_2/leadership/stamp-7219eb3da935c24cc0f9292fd5bb0a7696dc7ff729feb3cccf397110053177ae.webp"
			
				images["dov.webp"] =  "/assets/room_2/leadership/dov-f1f727233565aebbbbe5533099c57e9a9be802d4ddf51ff04283014ea8cf849a.webp"
			
				images["krakov_yudenrat.webp"] =  "/assets/room_2/leadership/krakov_yudenrat-f982e9df00ec3d3283a19ff30b87e4df8513560d1d5dcebfa49860a9fc36d449.webp"
			
				images["shwartz_painting.webp"] =  "/assets/room_2/leadership/shwartz_painting-8926d53791aad39245665c588d8fc84d20a97f02f07874e25879e6cb54eb4c24.webp"
			
		
			
				images["coupon.webp"] =  "/assets/room_2/mutual_aid/coupon-18d2b677f23750a27915222d043e0f0f3f58a3f0a0c762564a3b86366e1e00fa.webp"
			
				images["aliza.webp"] =  "/assets/room_2/mutual_aid/aliza-930fe257e70f1807968d71919013d0f50994276ffead6d220554cc4596c0124e.webp"
			
				images["orphanage.webp"] =  "/assets/room_2/mutual_aid/orphanage-62ae2286c08cb4d71c5be7a58cbe380d924f04785a4dc38473c33016643bf7e0.webp"
			
				images["haim-kaplan.webp"] =  "/assets/room_2/mutual_aid/haim-kaplan-18dd0c710fbea8204d93bdaab4ae8ecaaab6e593f6196fec46de0f24aaf72643.webp"
			
				images["medicine.webp"] =  "/assets/room_2/mutual_aid/medicine-44bfa3d38db2b08015f6454e4ec89c13c54aa4128a8f8184a7dfdce96a7a053d.webp"
			
				images["kitchen.webp"] =  "/assets/room_2/mutual_aid/kitchen-0fca7b807644c0a918c73ca4c03ba9d9cf0b613e334b2341d611128260e01971.webp"
			
		
			
				images["ruthke.webp"] =  "/assets/room_2/recording/ruthke-a8313061c01a02d97ed111271f63d33a157e0032e19da091314eb7d7397f64f0.webp"
			
				images["ringelblum_diary.webp"] =  "/assets/room_2/recording/ringelblum_diary-d8c8f4db0fb40c4c100e6d4234faaa923ddbd1ddd621909b55cf8b523c150917.webp"
			
				images["henrick.webp"] =  "/assets/room_2/recording/henrick-92848a776da88e7b4c16b5ecd6b9efb461f941a343a10b9d7cab94ee7c2cf711.webp"
			
				images["shapes_kaplan.webp"] =  "/assets/room_2/recording/shapes_kaplan-f87635b818f35b429fb0ade6de437807d80c8280bd659215673481773121860c.webp"
			
				images["keplan.webp"] =  "/assets/room_2/recording/keplan-eaf2e7d9a4bd476ef6c85b760e30f025eac9577055d70c8290374c13f3840379.webp"
			
				images["oneg.webp"] =  "/assets/room_2/recording/oneg-a99c8a5ae6e869174c0a7bf1eb9e1e60a082e0b2e0bc40fc38f019e06ecc50a4.webp"
			
				images["aharon-henrik.webp"] =  "/assets/room_2/recording/aharon-henrik-2d7491180cebbeb7c88c0a7a07d48b9d373c4a87a8f6ae5fe31512b7fe1155c3.webp"
			
				images["underground_newspaper.webp"] =  "/assets/room_2/recording/underground_newspaper-3bbc3a67a6c0187d10b0f001d525a17d5d8ffdd55c8e45ba1ffab4ac11963c6f.webp"
			
				images["shapes_letter.webp"] =  "/assets/room_2/recording/shapes_letter-8fbcb9eb330065450133ffb523b4058f126aeae3d7bf9857edef51ec33debc71.webp"
			
				images["recording.webp"] =  "/assets/room_2/recording/recording-546aeb418d5f59f8600eaac34614d123fe3efd002dc0e4a1bc13298ce6f140a7.webp"
			
				images["newspapers.webp"] =  "/assets/room_2/recording/newspapers-25e7882b9986994b951ac9d8338e78be1996607ebf8350cc7103e19b03b2144c.webp"
			
				images["ringelblum.webp"] =  "/assets/room_2/recording/ringelblum-d2897743ab027f2bad36a794e41a4308618ffab2edb14e71927a115a5d56f103.webp"
			
				images["miriam.webp"] =  "/assets/room_2/recording/miriam-af2a0dbc485100007ef21ac76b1b57ad45d00833e15a6fd1d15cdcc5f581888f.webp"
			
				images["shapes_shiron.webp"] =  "/assets/room_2/recording/shapes_shiron-f7d3bd357dc433b6e2461e26d8539d2b3980356cc0e54fe76dd3357f9a6627e8.webp"
			
				images["shapes_hilda.webp"] =  "/assets/room_2/recording/shapes_hilda-987cdd5a96107ccb6f24412e4039f036f8c63c11ba575c4a48f94b1f77aff52d.webp"
			
				images["shapes_toilet.webp"] =  "/assets/room_2/recording/shapes_toilet-19996d3c3e3b7f67c645930ee9bf8922952a7c7677c8ad48688bbcbdcbd26398.webp"
			
		
			
				images["ruthka2.webp"] =  "/assets/room_2/diaries/ruthka2-83b6152debe2e2a933593152972f5e334fb7c7f76af9917d13ba4a4c5fb7e0ea.webp"
			
				images["flinker_tirgulim.webp"] =  "/assets/room_2/diaries/flinker_tirgulim-158ad0b00c1aff0fe7d49c00402dbf4f5ce4a841b728959df3b232037eed3813.webp"
			
				images["flinker_cover.webp"] =  "/assets/room_2/diaries/flinker_cover-cc06a5a3538bf323ac44850790101dac420ac820fb3771a41a1d4073370a9ee2.webp"
			
				images["ruthka.webp"] =  "/assets/room_2/diaries/ruthka-057c941c49d2ce5cca37f46f9149af2a8bb102a48a062758d7084a8ae6c4eb2f.webp"
			
				images["flinker_diary.webp"] =  "/assets/room_2/diaries/flinker_diary-d5c18cb12145c39c7ae3b94176609cf2efd8258e4c114c0cb2c548ded2b82645.webp"
			
				images["opozinsky.webp"] =  "/assets/room_2/diaries/opozinsky-ffe2e83647e2160ce835ffb08588db107518609eac758aa7ed85e1de64c7f9ac.webp"
			
				images["david_s.webp"] =  "/assets/room_2/diaries/david_s-8e0774542f6a8659a587ce036bc317e6a869504ef0150fa3c3f1254771c91be0.webp"
			
				images["izhak_r.webp"] =  "/assets/room_2/diaries/izhak_r-56cef824bf7717e86e2c6d4116694f0c7a2a8a308874d14963d50c3effb69b98.webp"
			
				images["eva_h.webp"] =  "/assets/room_2/diaries/eva_h-d355af16956e01f50d13b12f9d78ddc0166bf8654d4da3f9a351066c3d363f6f.webp"
			
				images["miriam_h.webp"] =  "/assets/room_2/diaries/miriam_h-b4658b76febcbeac30576bec58a778357b270ef88a62ba4360c48e102c5ca029.webp"
			
				images["doris.webp"] =  "/assets/room_2/diaries/doris-5180c13e01bfc2cb8debe88f7e3a6b399b48ec4ee8e25e1595d2fd0f55224e1a.webp"
			
				images["david_r.webp"] =  "/assets/room_2/diaries/david_r-a7e4de1fe15dd467dbb59206dbdbe5a823e8a0deed060d56b36ace3a6d3dba04.webp"
			
				images["tamra_l.webp"] =  "/assets/room_2/diaries/tamra_l-741c2fdc0ffde2e7836c27f420fd02fa3e0aeb490006f1edb0e8df198dac8ce4.webp"
			
				images["flinker.webp"] =  "/assets/room_2/diaries/flinker-b08d7eebf13469d4e9b1e1c680f03bc925fa4909ef7e8cb498244ca7adeada93.webp"
			
		
			
				images["alfon.webp"] =  "/assets/room_2/education/alfon-1f8cc39823b6d453d517b85d71f1c0709c83bc6a150e34f55f13f2eb379be17d.webp"
			
				images["merishin.webp"] =  "/assets/room_2/education/merishin-888b0d726eab8ebc2eb6d751923aed44b06d5020d15e9f5f7e7515a72c9e424c.webp"
			
				images["school.webp"] =  "/assets/room_2/education/school-6911600a8b3e3a6acde1629d711f01890c9bbf6f813b8267325cef3aa8667deb.webp"
			
				images["korchak.webp"] =  "/assets/room_2/education/korchak-dc56ec28200e9af59f9f45231bea6c4eb85cc938712e03049729a67dc2899798.webp"
			
				images["david.webp"] =  "/assets/room_2/education/david-a7e4de1fe15dd467dbb59206dbdbe5a823e8a0deed060d56b36ace3a6d3dba04.webp"
			
				images["stefa.webp"] =  "/assets/room_2/education/stefa-527da291941301874b74a9a931869de3569986ac4b8555d029e2e9d5d98009c6.webp"
			
				images["tora.webp"] =  "/assets/room_2/education/tora-b238ad19c949f422bbffbc8df4238789f6d30f07b9ce1459aea6ba038dc915bd.webp"
			
		
			
				images["eti.webp"] =  "/assets/room_2/hope/eti-74387b6609119bb589cb4bd0f85985ee95174fa61c71bb2a4c3ad28a2fdd163b.webp"
			
				images["moshe.webp"] =  "/assets/room_2/hope/moshe-9fae7d41939e4bc629b153ee847892d937e9869638f5e97d9c87d3e043833530.webp"
			
				images["doris.webp"] =  "/assets/room_2/hope/doris-d08561da828f8dfd69aa98e5c74baa9e462a46f02ffe7abeee3a2cfcf233d901.webp"
			
				images["avramek.webp"] =  "/assets/room_2/hope/avramek-acc47f646681fe37a2626a938c72b386a244a15a305b68e27dc886fb8f741dcf.webp"
			
				images["tarzin.webp"] =  "/assets/room_2/hope/tarzin-b6d4c38337ba6929ff4f355ad94d168a707918a87bfdc7f2da1fe795bf3fe1c8.webp"
			
		
			
				images["rodoshevsky.webp"] =  "/assets/room_2/living_conditions/rodoshevsky-551af63a382a11ae4f2f2c2123c6a9e3d3465f306c52f608006f9033915f2386.webp"
			
				images["family.webp"] =  "/assets/room_2/living_conditions/family-2ec2b2810a5080ee7aa4a207dc7ec4ccb7a7f6947b4beee7cd8c99023ac5f647.webp"
			
				images["sitting.webp"] =  "/assets/room_2/living_conditions/sitting-a626f9c19c4c77356015dd9187aed85641590504f3de34e28080b35802948e21.webp"
			
				images["charity.webp"] =  "/assets/room_2/living_conditions/charity-9edef7dae35f52172cb997f5642b10df6469be9a8331b0cac43c2d0d24f633ad.webp"
			
				images["children_food.webp"] =  "/assets/room_2/living_conditions/children_food-9316ddcbd332c6061633b65024d46539952f20e3aa122e753e893c5df7e3ce89.webp"
			
				images["children_smugglers.webp"] =  "/assets/room_2/living_conditions/children_smugglers-70bde93ef1c1fa5d0aac927a1c12cd537d2dc68c5bdaf21b890a54e1c079667d.webp"
			
				images["armbands.webp"] =  "/assets/room_2/living_conditions/armbands-3a9a9e814f146b772a532953c7dc3421d745f4e1ccde6cbcc6d24a1498c51a89.webp"
			
				images["bread.webp"] =  "/assets/room_2/living_conditions/bread-94f12a1313bd448dd8f058faa867e66155849fe1ce1453c7c9bd36935d7a26e7.webp"
			
				images["warsaw_street.webp"] =  "/assets/room_2/living_conditions/warsaw_street-70eb9cb59e3501b3eb037b761d9833bdfe884a5eed0b0574671e5e26d44fd0d1.webp"
			
				images["labor.webp"] =  "/assets/room_2/living_conditions/labor-6ed2b1048555eeee1c32128304d572024406694713b98451db9abddaafa7963b.webp"
			
				images["bread-children.webp"] =  "/assets/room_2/living_conditions/bread-children-3b6af4ae06290c7a0b894320c6158c494cd8df58a0fd73ed29a02bb23e61ad8e.webp"
			
				images["entrance-warsaw-children.webp"] =  "/assets/room_2/living_conditions/entrance-warsaw-children-2911f822e16d8a7331dd3976458ad0d53f3da8bc767f74e73eb4aa27221a9507.webp"
			
				images["dying-charity.webp"] =  "/assets/room_2/living_conditions/dying-charity-ed82c5d8536f1d8f1d6724816147f2457b292bb5531289786b4ce69253b4795b.webp"
			
				images["wall.webp"] =  "/assets/room_2/living_conditions/wall-4598a6c77de4ef69997b8ca38be6a970b8d49915fd187dea8c2950437a4e2405.webp"
			
				images["anon.webp"] =  "/assets/room_2/living_conditions/anon-25d131bd46993e8311e4a99927e2f59e3f8130df745f7393402dd849f3df17bb.webp"
			
				images["lodz_entrance.webp"] =  "/assets/room_2/living_conditions/lodz_entrance-cae35c2a6956e96b8e055489b14e02c9f2eff58c887abf1b7e1104f6ce8812fa.webp"
			
				images["children_street.webp"] =  "/assets/room_2/living_conditions/children_street-7c66f94745f13c96958a16d404824b2fbf3db244ad65c22f2e3caffedcbc1091.webp"
			
		

		
			
				images["poda.webp"] =  "/assets/room_3/movement/poda-5f93eda2cffaadca7580f5ddf21614921de2ae6e2f20f2cd4db012b23d24cc75.webp"
			
				images["food.webp"] =  "/assets/room_3/movement/food-11a055ae6800b015c5787d349e7c87fc6a4c3d231f2d4d5fe1bb0fcbb8dfb7f7.webp"
			
				images["guttman.webp"] =  "/assets/room_3/movement/guttman-e60f5d7ab5a41bb89d3502f371245bda2b3caac80412391adac0e5eaad930ef5.webp"
			
				images["newspaper.webp"] =  "/assets/room_3/movement/newspaper-dd3e1367ecfe086cd7463e9f3bba12c10466d3277457fb7d13be8d78364aad30.webp"
			
				images["tosia.webp"] =  "/assets/room_3/movement/tosia-70be47c399b4a2961fcc094ab8416880e8a7e4e7c3b025346c0e966b794fd9a0.webp"
			
		
			
				images["mered.webp"] =  "/assets/room_3/rebellion/mered-7e5014211809c2875f7f4cd6fe8ac2f1645361d45fb75d61960f713bae914243.webp"
			
				images["rebellion_anilevich.webp"] =  "/assets/room_3/rebellion/rebellion_anilevich-3448d5c8be3faa35b94c6a6a421d58520a0a0333159a2908003069292c6999bb.webp"
			
				images["training.webp"] =  "/assets/room_3/rebellion/training-99c83e0f1d12b58eae15ea10c83604bd9eec2e9fbced5503fe452516a0914767.webp"
			
				images["ken.webp"] =  "/assets/room_3/rebellion/ken-2b91f10d495e2b363a1c9dfbfcfe06bdeb950842ffa5ce78f7b8f3bb0d363e0c.webp"
			
		
			
				images["leaders2.webp"] =  "/assets/room_3/rikuz/leaders2-c79cd860410d4905cfbefb5cc40e8e609e28cf1acd2b0d456b2d2051dc0033df.webp"
			
				images["rikuz_map.webp"] =  "/assets/room_3/rikuz/rikuz_map-a9f86c02b8d446480fbc6b4f963173de3d47d97894d2ca012491c1ad2b4139e5.webp"
			
		
			
				images["ghetto.webp"] =  "/assets/room_3/struggle/ghetto-68fc1e0170116d399ea46aae3e01fab949ac6750d1ac244aab618ab42f83847d.webp"
			
				images["eyal.webp"] =  "/assets/room_3/struggle/eyal-7c4bcb07a5a72561b9fb8bf924afa9e0e0b8f2a0027549bec8c1f773d2ec063f.webp"
			
				images["anilevich.webp"] =  "/assets/room_3/struggle/anilevich-7415cef1ae43e7b25ea65d13396c097a1bc0050a091831f2d1ec78fe8f1f606f.webp"
			
		
			
				images["tosia-quote.webp"] =  "/assets/room_3/kashariot/tosia-quote-304e65ce2b0199d1b72eac233de7f82a8e319b5db74efbf289ab056cd2eff360.webp"
			
				images["haika.webp"] =  "/assets/room_3/kashariot/haika-10eb34280b3716a0561bb5115666083f85f8f0230395e922ddcbe19323b60a7b.webp"
			
				images["aba.webp"] =  "/assets/room_3/kashariot/aba-5149ac71a0c65456bc225a4e674c32ddd865e9c16dc95e7f89ea03a98cdf2bc8.webp"
			
				images["tosia-map.webp"] =  "/assets/room_3/kashariot/tosia-map-1315b0a1e74e5bd6b48182a35a4b5b306d9e7c48907f868187520cc09b41d663.webp"
			
				images["empty_map.webp"] =  "/assets/room_3/kashariot/empty_map-b9d34125d1af43ca0f1bf4453f94bae007d61489437a94c920aba0899d8a47ea.webp"
			
				images["map.webp"] =  "/assets/room_3/kashariot/map-29ddbf067fd726252c3c01a1f1f249a359215b9359aed9b67b7bad4270b61c1d.webp"
			
				images["kashariot.webp"] =  "/assets/room_3/kashariot/kashariot-5565f378beccaac63f8b95bd97ce7419ea49f431cb8f79f28a55d566589af534.webp"
			
		
			
				images["partizans2.webp"] =  "/assets/room_3/partizans/partizans2-99a0884d25fd260b3a6ae0ba74932ae5ddc7af746cc4251f655e5a168d32edce.webp"
			
				images["kovner.webp"] =  "/assets/room_3/partizans/kovner-ebe715685afcd0e13d023a46958d6e95dc2cdba6d4af2db72e13150050bc33cf.webp"
			
		



		// function preloadImage(url)
		// {
		// 		let img=new Image();
		// 		img.src=images[img];
		// }
		const modal_image_buttons = () => {

			$(".image img").each(function(index, el) {
				// console.log($(el).offset().left);
				// console.log($(el).position().left);
				// console.log($(".image-image_" + index )[0]);
				if ($("#expand_image_" + index )[0] == undefined) {
					$(el).before("<button data-image='" + el.id + "' id='expand_image_" + index + "' class='resize-image expand-image'></button>");
				}
				$("#expand_" + el.id).last().css('left', $(el).position().left + $(el).width() - 40 ).css('top', $(el).position().top + 10 )
			})
	  }
	});
